export default __webpack_public_path__ + "static/media/vrf.2e63b9c9.jpeg";